import React from 'react';
import Alert from '@amzn/meridian/alert';
import Button from '@amzn/meridian/button';
import type { SessionMergeBannerContent } from './dataTransformations';

interface SessionMergeBanner extends SessionMergeBannerContent {
  onNavigate: (path: string) => void;
}

/** States how this session relates to a merge, with links to the related sessions. */
const SessionMergeBannerComponent: React.FC<SessionMergeBanner> = ({
  type,
  message,
  links,
  onNavigate,
}) => (
  <div style={{ padding: '8px 24px', flexShrink: 0 }}>
    <Alert type={type} size="medium">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <span>{message}</span>
        <span style={{ display: 'inline-flex', gap: '8px' }}>
          {links.map((link) => (
            <Button key={link.path} type="link" size="small" onClick={() => onNavigate(link.path)}>
              {link.label}
            </Button>
          ))}
        </span>
      </div>
    </Alert>
  </div>
);

export default SessionMergeBannerComponent;
